module.exports = __webpack_public_path__ + "static/img/wurenji.62b0061.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wurenji.png
// module id = qtl2
// module chunks = 21